import React from 'react';
import './Journey.css';

const LOG = [
  { period: '2025 → now',  role: 'Site Reliability Engineer', company: 'SITA',                              active: true  },
  { period: '2025 → now',  role: 'CNCF Jordan Organizer',     company: 'Cloud Native Computing Foundation', active: true  },
  { period: '2023 → now',  role: 'Technology Consultant',      company: 'Social Hive',                       active: true  },
  { period: '2023 → 2025', role: 'DevOps Engineer',            company: 'WUDUH',                             active: false },
  { period: '2022 → 2023', role: 'IT Specialist',              company: 'TDM Group',                         active: false },
  { period: '2015 → 2022', role: 'IT Operations',              company: 'Philadelphia Pharma · Umniah · Grand IT', active: false },
];

export default function Journey() {
  return (
    <section id="journey" className="journey">
      <div className="journey-bar">
        <span className="journey-label">// git log --author="shahd" --oneline</span>
      </div>
      <div className="journey-grid">
        {LOG.map((entry, i) => (
          <div key={i} className={`j-entry ${entry.active ? 'active' : ''}`}>
            <span className="j-symbol">{entry.active ? '+' : '~'}</span>
            <div className="j-info">
              <div className="j-role">{entry.role}</div>
              <div className="j-company">{entry.company}</div>
              {entry.active && <span className="j-badge">{i === 0 ? 'HEAD' : 'active'}</span>}
            </div>
            <div className="j-period">{entry.period}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
